const Luminous = require("luminous-lightbox").Luminous;
const LuminousGallery = require("luminous-lightbox").LuminousGallery;
// import 'luminous-lightbox/dist/luminous-basic.min.css';

("use strict");
let map;
let geocoder;
let latLng;
let zoom = 15;
let mapOptions;
let marker;
let markers;
let infoWindow;
let googleMapApiKey;
let facility_lists;
let barrierFreeIds;

let footerNavbarElement;
let navbarCollapseElement;
let leftContainerElement;
let facilityDetailElement;

let mapElement;
let areaElement;
let areaIdElement;
let streetElement;
let latitudeElement;
let longitudeElement;
let selectFacilityTypeElements;
let searchFacilityNameElement;
let btnSearchFacilityNameElement;

let serviceBaseUrl;
let facilityUrl;
let facilitySearchUrl;
let facilitiesKey;
let facilityKey;

let selectedAreaId;

let luminousElemCaption;
let luminousGalleryElems;

function updateAreaTitleAttributes() {
  var areaButtons = document.querySelectorAll(".btn-area-large, .btn-area-small");
  areaButtons.forEach(function (button) {
    var label = button.textContent.trim();
    if (!label) {
      button.removeAttribute("title");
      return;
    }
    var isTruncated = button.scrollWidth > button.clientWidth;
    if (isTruncated) {
      button.setAttribute("title", label);
    } else {
      button.removeAttribute("title");
    }
  });
}

//オプションの設定
const luminousOpts = {
  caption: (trigger) => {
    //a 要素に data-caption 属性が設定されていて、その値が空でない場合
    if (
      trigger.hasAttribute("data-caption") &&
      trigger.getAttribute("data-caption") !== ""
    ) {
      //a 要素の data-caption 属性の値をキャプションとして表示
      return trigger.getAttribute("data-caption");
    } else {
      //a 要素の data-caption 属性が設定されていなければ img 要素の alt 属性の値を表示
      return trigger.querySelector("img").getAttribute("alt");
    }
  },
};

document.addEventListener("DOMContentLoaded", function () {
  Facilities.init();
  setEventListener();
  // SP Height Change
  if (!facilityDetailElement) {
    if (mapElement) {
      if (Facilities.mobileAccess()) {
        mapElement.style.height = "55vh";
      }
    }
    Facilities.initMap();
  } else {
    Facilities.initDetailMap();
  }

  // ToucEvent
  let startX;
  let startY;
  let moveX;
  let moveY;
  let dist = 30;
  let distY = 60;

  if (footerNavbarElement) {
    footerNavbarElement.addEventListener("touchstart", function (e) {
      startX = e.touches[0].pageX;
      startY = e.touches[0].pageY;
    });
    footerNavbarElement.addEventListener("touchmove", function (e) {
      e.preventDefault();
      moveX = e.changedTouches[0].pageX;
      moveY = e.changedTouches[0].pageY;
    });
    footerNavbarElement.addEventListener("touchend", function (e) {
      var index;
      if (moveX == undefined || moveX == 0) {
        // スワイプなし時の処理
      } else if (startX > moveX && startX > moveX + dist) {
        // 右から左にスワイプした時の処理
        if (startY < moveY && startY + distY < moveY) {
          // 上から下にスワイプした時の処理
          if (navbarCollapse) {
            if (navbarCollapse.classList.contains("show")) {
              navbarCollapse.classList.remove("show");
            }
          }
        } else if (facilityDetail) {
          Facilities.next();
        }
      } else if (startX < moveX && startX + dist < moveX) {
        // 左から右にスワイプした時の処理
        // 下から上にスワイプした時の処理
        if (startY > moveY && startY > moveY + distY) {
          if (navbarCollapse) {
            if (!navbarCollapse.classList.contains("show")) {
              navbarCollapse.classList.add("show");
            }
          }
        } else if (facilityDetail) {
          Facilities.prev();
        }
      } else if (startY < moveY && startY + distY < moveY) {
        // 上から下にスワイプした時の処理
        if (navbarCollapse) {
          if (navbarCollapse.classList.contains("show")) {
            navbarCollapse.classList.remove("show");
          }
        }
      } else {
      }

      startX = 0;
      startY = 0;
      moveX = 0;
      moveY = 0;
    });
  }
});
function setEventListener() {
  updateAreaTitleAttributes();
  window.addEventListener("resize", updateAreaTitleAttributes);

  // Area button click (旧)
  var btnAreas = document.querySelectorAll(".btn-area");
  btnAreas.forEach(function (target) {
    target.addEventListener("click", function (e) {
      Facilities.changeMap(e.currentTarget);
    });
  });

  // Area button click (新: 大エリア + 全エリア)
  var btnAreasLarge = document.querySelectorAll(".btn-area-large");
  btnAreasLarge.forEach(function (target) {
    target.addEventListener("click", function (e) {
      Facilities.selectArea(e.currentTarget);
    });
  });

  // Area button click (新: 小エリア)
  var btnAreasSmall = document.querySelectorAll(".btn-area-small");
  btnAreasSmall.forEach(function (target) {
    target.addEventListener("click", function (e) {
      Facilities.selectArea(e.currentTarget);
    });
  });

  // Map button click
  var facilityMaps = document.querySelectorAll(".facility-map");
  facilityMaps.forEach(function (target) {
    target.addEventListener("click", function (e) {
      Facilities.panTo(e.currentTarget);
    });
  });
  // section scroll
  var btnSections = document.querySelectorAll(".btn-section");
  btnSections.forEach(function (target) {
    target.addEventListener("click", function (e) {
      Facilities.scrollToSection(e.currentTarget);
    });
  });

  // section scroll
  if (!facilityDetailElement) {
    var btnBarrierFrees = document.querySelectorAll(".btn-barrier-free");
    btnBarrierFrees.forEach(function (target) {
      target.addEventListener("click", function (e) {
        Facilities.selectBarrierFree(e.currentTarget);
      });
    });
  }

  // Facility Type
  if (selectFacilityTypeElements) {
    selectFacilityTypeElements.forEach(function (target) {
      target.addEventListener("change", function (e) {
        Facilities.changeFacilityType(e.currentTarget);
      });
      target.addEventListener("blur", function (e) {
        Facilities.changeFacilityType(e.currentTarget);
      });
    });
  }

  // Purpose Categories
  var selectPurposeCategoriesElements = document.querySelectorAll(".select-purpose-categories");
  if (selectPurposeCategoriesElements) {
    selectPurposeCategoriesElements.forEach(function (target) {
      target.addEventListener("change", function (e) {
        Facilities.changePurposeCategories(e.currentTarget);
      });
      target.addEventListener("blur", function (e) {
        Facilities.changePurposeCategories(e.currentTarget);
      });
    });
  }

  // facility selected
  var facilities = document.querySelectorAll(".facility");
  if (facilities) {
    facilities.forEach(function (target) {
      // target.style.display = "none"
      target.classList.add("selected");
    });
  }

  if (btnSearchFacilityNameElement) {
    btnSearchFacilityNameElement.addEventListener("click", function (e) {
      Facilities.setResult();
    });
  }

  var languageTypes = document.querySelectorAll(".language-type");
  if (languageTypes) {
    languageTypes.forEach(function (target) {
      target.addEventListener("click", function (e) {
        Facilities.setLocale(e.currentTarget);
      });
    });
  }

  luminousGalleryElems = document.querySelectorAll(".luminous");
  if (luminousGalleryElems.length > 0) {
    new LuminousGallery(luminousGalleryElems, {}, luminousOpts);
  }
}
function GetQueryString() {
  if (1 < document.location.search.length) {
    var query = document.location.search.substring(1);
    var parameters = query.split("&");
    var result = new Object();
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split("=");
      var paramName = decodeURIComponent(element[0]);
      var paramValue = decodeURIComponent(element[1]);
      result[paramName] = decodeURIComponent(paramValue);
    }
    return result;
  }
  return null;
}
var Facilities = {
  init: function () {
    facilityDetailElement = document.getElementById("facility_detail");
    footerNavbarElement = document.getElementById("footer_navbar");
    navbarCollapseElement = document.getElementById("navbar");
    leftContainerElement = document.getElementById("left_container");

    mapElement = document.getElementById("map");
    areaIdElement = document.getElementById("facility_area_id");
    areaElement = document.getElementById("facility_area_code");
    streetElement = document.getElementById(
      "facility_addresses_attributes_0_street",
    );
    latitudeElement = document.getElementById(
      "facility_addresses_attributes_0_latitude",
    );
    longitudeElement = document.getElementById(
      "facility_addresses_attributes_0_longitude",
    );
    selectFacilityTypeElements = document.querySelectorAll(
      ".select-facility-type",
    );
    searchFacilityNameElement = document.getElementById("facility_name");
    btnSearchFacilityNameElement = document.getElementById(
      "btn_search_facility_name",
    );

    serviceBaseUrl = location.origin;
    facilityUrl = serviceBaseUrl + "/api/v1/facilities.json";
    facilitySearchUrl = serviceBaseUrl + "/api/v1/facilities/search.json";
    facilitiesKey = "facilities";
    facilityKey = "facility";

    googleMapApiKey = "AIzaSyAHTeIkbYyuzdQ2QMe8KmkshwBGeZESooc";
    geocoder = new google.maps.Geocoder();
    barrierFreeIds = [];
  },
  initMap: function () {
    var defaultLatitude = 37.7542123;
    var defaultLongitude = 140.4640277;
    var areaId;
    var latitude;
    var longitude;

    // var src = 'https://developers.google.com/maps/documentation/javascript/examples/kml/westcampus.kml';
    // var src = 'https://test.barrier-free.sisay.jp/fukushima_city2.kml'
    // var src = 'https://dev-sisay-jp.s3.ap-northeast-1.amazonaws.com/fukushima_city3.kml'

    if (Facilities.storageAvailable("sessionStorage")) {
      latitude = sessionStorage.getItem("latitude");
      longitude = sessionStorage.getItem("longitude");
    }
    if (latitude == null) {
      latitude = defaultLatitude;
    }
    if (longitude == null) {
      longitude = defaultLongitude;
    }
    // 複数選択対応のため、areaIdは使用しない
    areaId = 0;
    // 施設タイプの選択状態を復元（複数選択対応）
    if (sessionStorage.getItem("facility_type_ids")) {
      try {
        var facilityTypeIds = JSON.parse(sessionStorage.getItem("facility_type_ids"));
        var facilityTypeSelectElements = document.querySelectorAll(".select-facility-type");
        facilityTypeSelectElements.forEach(function (selectElement) {
          var options = selectElement.options;
          for (var i = 0; i < options.length; i++) {
            if (facilityTypeIds.includes(options[i].value)) {
              options[i].selected = true;
            }
          }
          // カスタムマルチセレクトのインスタンスがあれば更新
          if (selectElement.customMultiSelect) {
            selectElement.customMultiSelect.selectedValues = new Set(facilityTypeIds);
            selectElement.customMultiSelect.updateDropdownText();
          }
        });
      } catch (e) {
        console.error("Error restoring facility type selection:", e);
      }
    }
    this.applyBarrierFreeSelectionFromParams();
    if (sessionStorage.getItem("barrier_free_ids")) {
      barrierFreeIds = sessionStorage
        .getItem("barrier_free_ids")
        .split(",")
        .map(Number);
      var barrierFreeNodes = document.querySelectorAll(".btn.btn-barrier-free");
      barrierFreeNodes.forEach(function (target) {
        for (var i = 0; i < barrierFreeIds.length; i++) {
          if (target.dataset.value == barrierFreeIds[i]) {
            target.classList.add("selected");
            break;
          }
        }
      });
    }
    this.applyPurposeSelectionFromParams();
    // 目的カテゴリの選択状態を復元
    if (sessionStorage.getItem("purpose_category_ids")) {
      try {
        var purposeCategoryIds = JSON.parse(sessionStorage.getItem("purpose_category_ids"));
        var purposeSelectElements = document.querySelectorAll(".select-purpose-categories");
        purposeSelectElements.forEach(function (selectElement) {
          var options = selectElement.options;
          for (var i = 0; i < options.length; i++) {
            if (purposeCategoryIds.includes(options[i].value)) {
              options[i].selected = true;
            }
          }
          // カスタムマルチセレクトのインスタンスがあれば更新
          if (selectElement.customMultiSelect) {
            selectElement.customMultiSelect.selectedValues = new Set(
              purposeCategoryIds.map(String),
            );
            selectElement.customMultiSelect.updateDropdownText();
          }
        });
      } catch (e) {
        console.error("Error restoring purpose category selection:", e);
      }
    }
    latLng = new google.maps.LatLng(latitude, longitude);
    if (mapElement) {
      if (this.mobileAccess()) {
        mapOptions = {
          zoom: zoom,
          center: latLng,
          mapTypeId: "roadmap",
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          },
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT,
          },
          zoomControl: false,
        };
      } else {
        mapOptions = {
          zoom: zoom,
          center: latLng,
          mapTypeId: "roadmap",
        };
      }
      map = new google.maps.Map(mapElement, mapOptions);

      // var kmlLayer = new google.maps.KmlLayer(src, {
      //   suppressInfoWindows: true,
      //   preserveViewport: false,
      //   map: map
      // });

      // kmlLayer.addListener('click', function(event) {
      //   var content = event.featureData.infoWindowHtml;
      //   var testimonial = document.getElementById('capture');
      //   testimonial.innerHTML = content;
      // });
    }
    this.applyAreaSelectionFromParams();
    this.searchFacilities(areaId);
  },
  applyPurposeSelectionFromParams: function () {
    var params = GetQueryString();
    if (!params || !params.category) {
      return;
    }

    var rawCategories = params.category.split(",").map((v) => v.trim()).filter(Boolean);
    if (rawCategories.length === 0) {
      return;
    }

    var purposeCodeToIdMap = window.purposeCodeToIdMap || {};
    var purposeIds = [];

    rawCategories.forEach(function (code) {
      var id = purposeCodeToIdMap[code];
      if (id) {
        purposeIds.push(id);
      }
    });

    if (purposeIds.length > 0 && Facilities.storageAvailable("sessionStorage")) {
      sessionStorage.setItem(
        "purpose_category_ids",
        JSON.stringify(purposeIds.map(String)),
      );
    }

    var updatePurposeSelectUI = function () {
      var pendingInit = false;
      var purposeSelectElements = document.querySelectorAll(".select-purpose-categories");
      purposeSelectElements.forEach(function (selectElement) {
        var options = selectElement.options;
        for (var i = 0; i < options.length; i++) {
          options[i].selected = purposeIds.includes(Number(options[i].value));
        }
        if (selectElement.customMultiSelect) {
          selectElement.customMultiSelect.selectedValues = new Set(
            purposeIds.map(String),
          );
          selectElement.customMultiSelect.updateDropdownText();
        } else {
          pendingInit = true;
        }
      });

      if (pendingInit) {
        setTimeout(updatePurposeSelectUI, 0);
      }
    };

    updatePurposeSelectUI();
  },
  applyBarrierFreeSelectionFromParams: function () {
    var params = GetQueryString();
    if (!params || !params.facilities) {
      return;
    }

    var rawFacilities = params.facilities.split(",").map((v) => v.trim()).filter(Boolean);
    if (rawFacilities.length === 0) {
      return;
    }

    var codeToIdMap = window.barrierFreeCodeToIdMap || {};
    var barrierIds = [];
    rawFacilities.forEach(function (code) {
      var id = codeToIdMap[code];
      if (id) {
        barrierIds.push(Number(id));
      }
    });

    if (barrierIds.length === 0) {
      return;
    }

    barrierFreeIds = barrierIds;
    if (Facilities.storageAvailable("sessionStorage")) {
      sessionStorage.setItem("barrier_free_ids", barrierIds.join(","));
    }

    var barrierFreeNodes = document.querySelectorAll(".btn.btn-barrier-free");
    barrierFreeNodes.forEach(function (target) {
      var value = Number(target.dataset.value);
      if (barrierIds.includes(value)) {
        target.classList.add("selected");
      } else {
        target.classList.remove("selected");
      }
    });
  },
  initDetailMap: function () {
    var latitude = 37.7542123;
    var longitude = 140.4570277;
    var draggable = true;
    if (mapElement) {
      if (facilityDetailElement) {
        draggable = false;
      }

      if (latitudeElement && longitudeElement) {
        if (latitudeElement.value != "") {
          latitude = parseFloat(latitudeElement.value);
        }
        if (longitudeElement.value != "") {
          longitude = parseFloat(longitudeElement.value);
        }
      }

      latLng = new google.maps.LatLng(latitude, longitude);
      let options = {
        zoom: zoom,
        center: latLng,
        mapTypeId: "roadmap",
      };
      map = new google.maps.Map(mapElement, options);
      marker = new google.maps.Marker({
        position: latLng,
        draggable: draggable,
        map: map,
        icon: {
          url: "/assets/images/pin3.png",
          scaledSize: new google.maps.Size(32, 43),
        },
        optimized: false,
      });
      google.maps.event.addListener(marker, "dragend", function (e) {
        ((latitudeElement.value = e.latLng.lat()),
          (longitudeElement.value = e.latLng.lng()));
      });
      marker.setMap(map);
      map.panTo(latLng);
    }
  },
  changeFacilityType: function (ele) {
    if (ele.classList.contains("select-facility-type")) {
      // マルチセレクトの選択値を取得
      var selectedOptions = Array.from(ele.selectedOptions).map(option => option.value).filter(v => v !== '');
      if (Facilities.storageAvailable("sessionStorage")) {
        sessionStorage.setItem("facility_type_ids", JSON.stringify(selectedOptions));
      }
    }
    this.setResult();
  },
  changePurposeCategories: function (ele) {
    if (ele.classList.contains("select-purpose-categories")) {
      // マルチセレクトの選択値を取得
      var selectedOptions = Array.from(ele.selectedOptions).map(option => option.value).filter(v => v !== '');
      if (Facilities.storageAvailable("sessionStorage")) {
        sessionStorage.setItem("purpose_category_ids", JSON.stringify(selectedOptions));
      }
    }
    this.setResult();
  },
  changeMap: function (ele) {
    var areaCode;
    var areaId;

    areaCode = ele.getAttribute("data-area-code");
    areaId = ele.getAttribute("data-area-id");
    if (Facilities.storageAvailable("sessionStorage")) {
      sessionStorage.setItem("area_id", areaId);
    }
    switch (areaCode) {
      case "FukushimaCity":
        Facilities.toFukushimaCity();
        break;
      case "Tsuchiyu":
        Facilities.toTsuchiyu();
        break;
      case "Takayu":
        Facilities.toTakayu();
        break;
      case "Iizaka":
        Facilities.toIizaka();
        break;
      case "Suburbs":
        Facilities.toSuburbs();
        break;
      default:
        Facilities.toFukushimaCity();
        break;
    }
    this.searchFacilities(areaId);
  },
  selectArea: function (ele) {
    var areaCode = ele.getAttribute("data-area-code");
    var areaId = ele.getAttribute("data-area-id");
    var isAllArea = ele.classList.contains("btn-area-all");
    var isLargeArea = ele.classList.contains("btn-area-large") && !isAllArea;
    var isSmallArea = ele.classList.contains("btn-area-small");

    // 全エリアボタンの場合
    if (isAllArea) {
      var isCurrentlyActive = ele.classList.contains("active");

      if (isCurrentlyActive) {
        // 全エリアを解除 = 全てのボタンをinactiveに
        document
          .querySelectorAll(".btn-area-large, .btn-area-small")
          .forEach(function (btn) {
            btn.classList.remove("active");
          });
        // セッションから削除
        if (Facilities.storageAvailable("sessionStorage")) {
          sessionStorage.removeItem("area_id");
          sessionStorage.removeItem("area_code");
        }
      } else {
        // 全エリアを選択 = 全てのボタンをactiveに
        document
          .querySelectorAll(".btn-area-large, .btn-area-small")
          .forEach(function (btn) {
            btn.classList.add("active");
          });
        // 全エリアの場合はarea_idを空に（全件検索）
        if (Facilities.storageAvailable("sessionStorage")) {
          sessionStorage.setItem("area_id", "");
          sessionStorage.setItem("area_code", "");
        }
      }
    }
    // 大エリアボタンの場合（固定6エリア）
    else if (isLargeArea) {
      var isCurrentlyActive = ele.classList.contains("active");

      if (isCurrentlyActive) {
        // 既に選択されている場合は解除
        ele.classList.remove("active");
      } else {
        // このエリアを選択
        ele.classList.add("active");
      }

      // 全エリアボタンの状態更新
      this.updateAllAreaButton();
    }
    // 小エリアボタンの場合
    else if (isSmallArea) {
      // このボタンの状態をトグル
      ele.classList.toggle("active");

      // 全エリアボタンの状態更新
      this.updateAllAreaButton();
    }

    this.panToSelectedArea();

    // フィルタリングを実行（既にロード済みのデータをフィルタ）
    this.setResult();
  },
  applyAreaSelectionFromParams: function () {
    var params = GetQueryString();
    if (!params || !params.areas) {
      return;
    }

    var rawAreas = params.areas.split(",").map((v) => v.trim()).filter(Boolean);
    if (rawAreas.length === 0) {
      return;
    }

    var areaCodeToIdMap = window.areaCodeToIdMap || {};

    document.querySelectorAll(".btn-area-large, .btn-area-small").forEach(function (btn) {
      btn.classList.remove("active");
    });

    var applied = false;
    rawAreas.forEach(function (code) {
      var largeBtn = document.querySelector(
        '.btn-area-large[data-area-code="' + code + '"]',
      );
      if (largeBtn) {
        largeBtn.classList.add("active");
        applied = true;
      }

      var smallCode = areaCodeToIdMap[code] ? code : null;
      var smallBtn = null;
      if (smallCode) {
        smallBtn = document.querySelector(
          '.btn-area-small[data-area-code="' + smallCode + '"]',
        );
      }
      if (smallBtn) {
        smallBtn.classList.add("active");
        applied = true;
      }
    });

    if (applied) {
      this.updateAllAreaButton();
      this.panToSelectedArea();
    }
  },
  panToSelectedArea: function () {
    // 親子関係マップ（大エリアcode -> 小エリアcodeの配列）
    var parentChildMap = {
      'north': ['iizaka_onsen'],
      'west': ['takayu_onsen', 'tsuchiyu_onsen'],
      'central': ['central_city_area'],
      'east': [],
      'south': []
    };

    // 各エリアの座標マップ
    var areaCoordinates = {
      // 大エリア
      'north': { lat: 37.7969101, lng: 140.4789657 },
      'west': { lat: 37.7234141, lng: 140.3613488 },
      'central': { lat: 37.7565687, lng: 140.4597355 },
      'east': { lat: 37.7495891, lng: 140.4852060 },
      'south': { lat: 37.6978872, lng: 140.472317 },
      // 小エリア
      'iizaka_onsen': { lat: 37.8303601, lng: 140.4546566 },
      'takayu_onsen': { lat: 37.7525393, lng: 140.3049014 },
      'tsuchiyu_onsen': { lat: 37.6822407, lng: 140.3265106 },
      'central_city_area': { lat: 37.7565687, lng: 140.4597355 }
    };

    // 1. 選択されている大エリアを取得
    var selectedLargeAreas = [];
    document.querySelectorAll(".btn-area-large.active:not(.btn-area-all)").forEach(function(btn) {
      var code = btn.getAttribute("data-area-code");
      if (code) {
        selectedLargeAreas.push(code);
      }
    });

    // 2. 選択されている小エリアを取得
    var selectedSmallAreas = [];
    document.querySelectorAll(".btn-area-small.active").forEach(function(btn) {
      var code = btn.getAttribute("data-area-code");
      if (code) {
        selectedSmallAreas.push(code);
      }
    });

    // 3. 計算に使用するエリアを決定
    var areasForCalculation = [];

    if (selectedLargeAreas.length > 0) {
      // 大エリアが選択されている場合
      areasForCalculation = selectedLargeAreas.slice();

      // 小エリアのうち、親子関係にないものを追加
      selectedSmallAreas.forEach(function(smallCode) {
        var isChildOfSelected = false;
        for (var i = 0; i < selectedLargeAreas.length; i++) {
          var largeCode = selectedLargeAreas[i];
          var children = parentChildMap[largeCode] || [];
          if (children.indexOf(smallCode) !== -1) {
            isChildOfSelected = true;
            break;
          }
        }
        if (!isChildOfSelected) {
          areasForCalculation.push(smallCode);
        }
      });
    } else {
      // 大エリアが選択されていない場合、小エリアのみ使用
      areasForCalculation = selectedSmallAreas.slice();
    }

    // 4. 座標の平均を計算
    if (areasForCalculation.length > 0) {
      var totalLat = 0;
      var totalLng = 0;
      var validCount = 0;

      areasForCalculation.forEach(function(areaCode) {
        var coords = areaCoordinates[areaCode];
        if (coords) {
          totalLat += coords.lat;
          totalLng += coords.lng;
          validCount++;
        }
      });

      if (validCount > 0) {
        var avgLat = totalLat / validCount;
        var avgLng = totalLng / validCount;

        // 5. ズームレベルを決定（エリア数に応じて調整）
        var zoomLevel;
        if (validCount === 1) {
          zoomLevel = 14;  // 単一エリア
        } else if (validCount <= 3) {
          zoomLevel = 12;  // 2-3エリア
        } else {
          zoomLevel = 12;  // 4エリア以上
        }

        // 6. 地図を移動
        this.drawMap(avgLat, avgLng, zoomLevel);
      }
    }
  },
  updateAllAreaButton: function () {
    // 全ての大エリア・小エリアボタンの状態を確認
    var allButtons = document.querySelectorAll(
      ".btn-area-large:not(.btn-area-all), .btn-area-small",
    );
    var activeButtons = document.querySelectorAll(
      ".btn-area-large.active:not(.btn-area-all), .btn-area-small.active",
    );
    var allAreaButton = document.querySelector(".btn-area-all");

    if (allAreaButton) {
      // 全てのボタンがactiveなら全エリアもactive
      if (allButtons.length === activeButtons.length && allButtons.length > 0) {
        allAreaButton.classList.add("active");
      } else {
        allAreaButton.classList.remove("active");
      }
    }
  },
  drawMap: function (latitude, longitude, level) {
    if (latitude && longitude) {
      latLng = new google.maps.LatLng(latitude, longitude);
      map.panTo(latLng);
      if (Facilities.storageAvailable("sessionStorage")) {
        sessionStorage.setItem("latitude", latitude);
        sessionStorage.setItem("longitude", longitude);
      }
    }
    if (level != undefined) {
      map.setZoom(level);
    } else {
      map.setZoom(zoom);
    }
  },
  createRequest: function (url, method, data) {
    var request = new Request(url, {
      method: method,
      mode: "cors",
      credentials: "same-origin",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: data,
      cache: "no-cache",
    });
    return request;
  },
  search: function (address) {
    if (geocoder && address) {
      geocoder.geocode(
        {
          address: address,
          region: "jp",
        },
        function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (marker) {
              marker.setMap(null);
              marker = null;
            }
            map.setCenter(results[0].geometry.location);
            var bounds = new google.maps.LatLngBounds();
            for (var r in results) {
              if (results[r].geometry) {
                latLng = results[r].geometry.location;
                bounds.extend(latLng);
                marker = new google.maps.Marker({
                  position: latLng,
                  draggable: true,
                  map: map,
                });
                google.maps.event.addListener(marker, "dragend", function (e) {
                  latitudeElement.value = e.latLng.lat();
                  longitudeElement.value = e.latLng.lng();
                });
                marker.setMap(map);
              }
            }
          }
        },
      );
    }
  },
  searchFacilities: function (val) {
    var hash = {
      facility: {
        area_id: val,
      },
    };
    var locale = this.getLocale();
    if (locale) {
      hash["facility"]["locale"] = locale;
    }
    var data = JSON.stringify(hash);
    var request = this.createRequest(facilitySearchUrl, "POST", data);
    fetch(request)
      .then((response) => response.json())
      .then((json) => this.addFacilities(json))
      .catch((error) => console.log(error));
  },
  addFacilities: function (json) {
    var facilities = json[facilitiesKey];
    if (facilities) {
      markers && markers.map((m) => m.marker.setMap(null));
      markers = [];
      facility_lists = [];
      var addedFacilities = [];
      for (var i = 0; i < facilities.length; i++) {
        var facility = {};
        var latLng;
        // var infoWindow
        var _id;
        var _title;
        var _tel;
        var _street;
        var _latitude;
        var _longitude;
        var _url;
        var _area_id;
        var _facility_type;
        var _facility_type_id;
        var _facility_type_name;
        var _category_structs;
        var categories = [];
        var marker_info = {};

        _id = facilities[i].id;
        _title = facilities[i].name;
        _tel = facilities[i].tel;
        _url = facilities[i].url;
        _area_id = facilities[i].area_id;
        _facility_type = facilities[i].facility_type;
        _facility_type_id = facilities[i].facility_type_id;
        _facility_type_name = facilities[i].facility_type_name;

        _category_structs = facilities[i]["category_structs"];

        if (facilities[i].addresses) {
          _street = facilities[i].addresses[0].street;
          _latitude = facilities[i].addresses[0].latitude;
          _longitude = facilities[i].addresses[0].longitude;
        }
        if (_category_structs) {
          for (var iy = 0; iy < _category_structs.length; iy++) {
            var category = {};
            category.id = _category_structs[iy]["category"]["id"];
            category.name = _category_structs[iy]["category"]["name"];
            category.code = _category_structs[iy]["category"]["code"];
            category.category_type = _category_structs[iy]["category"]["category_type"];
            categories.push(category);
          }
        }
        facility.id = _id;
        facility.title = _title;
        facility.facility_type = _facility_type;
        facility.tel = _tel;
        facility.street = _street;
        facility.latitude = _latitude;
        facility.longitude = _longitude;
        facility.url = _url;
        facility.area_id = _area_id;
        facility.facility_type = _facility_type;
        facility.facility_type_id = _facility_type_id;
        facility.facility_type_name = _facility_type_name;

        facility.categories = categories;

        facility_lists.push(facility);

        if (_latitude && _longitude) {
          latLng = {
            lat: parseFloat(_latitude),
            lng: parseFloat(_longitude),
          };
        }
        if (latLng) {
          var _marker = new google.maps.Marker({
            title: _title,
            map: map,
            position: latLng,
            // animation: google.maps.Animation.DROP,
            icon: {
              url: "/assets/images/pin3.png",
              scaledSize: new google.maps.Size(32, 43),
            },
            optimized: false,
          });

          _marker.addListener("click", function (e) {
            Facilities.setInfoWindow(e, this);
          });
          marker_info.facility_id = facility.id;
          marker_info.title = facility.title;
          marker_info.marker = _marker;
          markers.push(marker_info);
          _marker.setMap(map);
        }
      }
    }
    this.setResult();
  },
  selectBarrierFree: function (ele) {
    var selectTargetId;
    selectTargetId = ele.getAttribute("data-value");
    if (ele.classList.contains("selected")) {
      ele.classList.remove("selected");
      barrierFreeIds = barrierFreeIds.filter((n) => n !== selectTargetId);
    } else {
      ele.classList.add("selected");
      barrierFreeIds.push(selectTargetId);
    }
    if (Facilities.storageAvailable("sessionStorage")) {
      sessionStorage.setItem("barrier_free_ids", barrierFreeIds);
    }
    this.setResult();
  },
  setResult: function () {
    var facilityNodes = document.querySelectorAll(".facility");
    var facilityName;
    if (searchFacilityNameElement) {
      facilityName = searchFacilityNameElement.value;
    }
    var selectedBarrierFreeNodes = document.querySelectorAll(
      ".btn.btn-barrier-free.selected",
    );
    if (selectedBarrierFreeNodes) {
      barrierFreeIds = [];
      selectedBarrierFreeNodes.forEach(function (target) {
        barrierFreeIds.push(target.dataset.value);
      });
      if (Facilities.storageAvailable("sessionStorage")) {
        sessionStorage.setItem("barrier_free_ids", barrierFreeIds);
      }
    }

    // 施設タイプの選択状態を取得（複数選択対応）
    var selectedFacilityTypeIds = [];
    var facilityTypeIdsStr = sessionStorage.getItem("facility_type_ids");
    if (facilityTypeIdsStr) {
      try {
        selectedFacilityTypeIds = JSON.parse(facilityTypeIdsStr).map(Number);
      } catch (e) {
        selectedFacilityTypeIds = [];
      }
    }

    // グローバル変数からエリアマッピングを取得（ヘルパーから埋め込まれた情報）
    var areaIdToParentCodeMap = window.areaIdToParentCodeMap || {};
    var areaCodeToIdMap = window.areaCodeToIdMap || {};

    // 固定の小エリアコード一覧
    var fixedSmallAreaCodes = ['iizaka_onsen', 'takayu_onsen', 'tsuchiyu_onsen', 'central_city_area'];

    // 選択されているエリアを取得
    var selectedLargeAreaCodes = [];
    var selectedSmallAreaCodes = [];
    var selectedSmallAreaIds = [];

    // 選択されている大エリアのコードを取得（全エリアボタン以外）
    document.querySelectorAll(".btn-area-large.active:not(.btn-area-all)").forEach(function(btn) {
      var code = btn.getAttribute("data-area-code");
      if (code) {
        selectedLargeAreaCodes.push(code);
      }
    });

    // 選択されている小エリアのコードとIDを取得
    document.querySelectorAll(".btn-area-small.active").forEach(function(btn) {
      var code = btn.getAttribute("data-area-code");
      var areaId = btn.getAttribute("data-area-id");
      if (code) {
        selectedSmallAreaCodes.push(code);
      }
      if (areaId) {
        selectedSmallAreaIds.push(Number(areaId));
      }
    });

    // エリアが何も選択されていない場合は全件表示
    var isAllAreaSelected = selectedLargeAreaCodes.length === 0 && selectedSmallAreaCodes.length === 0;

    console.log('DEBUG Area Filter:', {
      selectedLargeAreaCodes: selectedLargeAreaCodes,
      selectedSmallAreaIds: selectedSmallAreaIds,
      isAllAreaSelected: isAllAreaSelected,
      areaIdToParentCodeMap: areaIdToParentCodeMap
    });

    // 目的カテゴリの選択状態を取得
    var selectedPurposeCategoryIds = [];
    var purposeCategoryIdsStr = sessionStorage.getItem("purpose_category_ids");
    if (purposeCategoryIdsStr) {
      try {
        selectedPurposeCategoryIds = JSON.parse(purposeCategoryIdsStr).map(Number);
      } catch (e) {
        selectedPurposeCategoryIds = [];
      }
    }

    if (facilityNodes) {
      var results = [];
      facilityNodes.forEach(function (target) {
        var result = false;
        var facilityId = null;
        var areaId = null;
        var title = null;
        var isTitle = false;
        var isArea = false;
        var isFacilityType = false;
        var isPurposeCategory = false;
        var isBarrierFreeIds = false;
        facilityId = target.dataset.facilityId;
        title = target.dataset.title;

        if (facilityId) {
          facilityId = Number(facilityId);

          if (facilityName) {
            isTitle = title.includes(facilityName);
          } else {
            isTitle = true;
          }

          // facility_list との比較
          if (facility_lists) {
            for (var i = 0; i < facility_lists.length; i++) {
              if (facility_lists[i].id == facilityId) {
                // area_id との比較（複数エリア対応のフィルタリング）
                areaId = Number(facility_lists[i].area_id);

                if (isAllAreaSelected) {
                  // エリアが何も選択されていない場合は全件表示
                  isArea = true;
                } else {
                  // 選択されているエリアのいずれかに一致するかチェック
                  isArea = false;

                  // 小エリアIDで直接一致をチェック
                  if (selectedSmallAreaIds.length > 0) {
                    if (selectedSmallAreaIds.includes(areaId)) {
                      isArea = true;
                    }
                  }

                  // 大エリアコードで親コードの一致をチェック
                  if (!isArea && selectedLargeAreaCodes.length > 0) {
                    var facilityParentCode = areaIdToParentCodeMap[areaId];
                    if (facilityParentCode && selectedLargeAreaCodes.includes(facilityParentCode)) {
                      isArea = true;
                    }
                  }

                  // デバッグ: 最初の施設のみログ出力
                  if (i === 0) {
                    console.log('DEBUG First Facility Area Check:', {
                      facilityName: facility_lists[i].title,
                      facilityAreaId: areaId,
                      facilityParentCode: areaIdToParentCodeMap[areaId],
                      isArea: isArea
                    });
                  }
                }

                // facility_type との比較（複数選択対応）
                if (selectedFacilityTypeIds.length > 0) {
                  if (selectedFacilityTypeIds.includes(facility_lists[i].facility_type_id)) {
                    isFacilityType = true;
                  } else {
                    isFacilityType = false;
                  }
                } else {
                  isFacilityType = true;
                }

                // 目的カテゴリとの比較
                if (selectedPurposeCategoryIds.length > 0) {
                  if (facility_lists[i].categories) {
                    var _categories = facility_lists[i].categories;
                    isPurposeCategory = false;

                    for (var ip = 0; ip < selectedPurposeCategoryIds.length; ip++) {
                      for (var ic = 0; ic < _categories.length; ic++) {
                        // category_type = 'purpose' のカテゴリのみをチェック
                        if (_categories[ic].category_type === 'purpose') {
                          var _pid = selectedPurposeCategoryIds[ip];
                          var _cid = _categories[ic].id;
                          if (_pid == _cid) {
                            isPurposeCategory = true;
                            break;
                          }
                        }
                      }
                      if (isPurposeCategory) break;
                    }
                  } else {
                    isPurposeCategory = false;
                  }
                } else {
                  isPurposeCategory = true;
                }

                // category との比較
                if (barrierFreeIds.length > 0) {
                  if (facility_lists[i].categories) {
                    var matchCount = 0;
                    var _categories = facility_lists[i].categories;
                    for (var ib = 0; ib < barrierFreeIds.length; ib++) {
                      for (var ic = 0; ic < _categories.length; ic++) {
                        var _bid = Number(barrierFreeIds[ib]);
                        var _cid = _categories[ic].id;
                        if (_bid == _cid) {
                          matchCount++;
                        }
                      }
                    }
                    if (matchCount == barrierFreeIds.length) {
                      isBarrierFreeIds = true;
                    } else {
                      isBarrierFreeIds = false;
                    }
                  } else {
                    isBarrierFreeIds = false;
                  }
                } else {
                  isBarrierFreeIds = true;
                }
                break;
              }
            }
          }
          if (isTitle && isArea && isFacilityType && isPurposeCategory && isBarrierFreeIds) {
            result = true;
          }
        }

        if (result) {
          target.style.display = "block";
          results.push(facilityId);
        } else {
          target.style.display = "none";
        }
      });
    }
    // marker
    if (markers) {
      for (var i = 0; i < markers.length; i++) {
        markers[i].marker.setMap(null);
        if (results.includes(markers[i].facility_id)) {
          markers[i].marker.setMap(map);
        }
      }
    }
  },
  panTo: function (ele) {
    var latitude = ele.getAttribute("data-latitude");
    var longitude = ele.getAttribute("data-longitude");
    var facility_id = ele.getAttribute("data-facility-id");
    var latLng = new google.maps.LatLng(latitude, longitude);
    if (markers) {
      for (var i = 0; i < markers.length; i++) {
        if (facility_id == markers[i].facility_id) {
          markers[i].marker.setAnimation(google.maps.Animation.BOUNCE);
          // markers[i].marker.setMap(map);
        } else {
          markers[i].marker.setAnimation(null);
        }
      }
    }
    if (mapElement) {
      if (this.mobileAccess()) {
        document.getElementById("sidebarMenuDropdown").click();
      }
    }
    // latLng = new google.maps.LatLng(37.7436845,140.2998417)
    map.panTo(latLng);
  },
  setInfoWindow: function (evt, target) {
    var lang = location.href.substring(location.origin.length + 1);
    if (lang.length > 2) {
      lang = lang.substring(0, 2);
    } else {
      lang = "ja";
    }
    var detail = "詳細";
    var route = "経路";

    if (lang === "en") {
      detail = "Detail";
      route = "Route";
    }

    if (facility_lists) {
      for (var i = 0; i < facility_lists.length; i++) {
        if (facility_lists[i].title == target.title) {
          var _url = facility_lists[i].url;
          var _lang = this.getLocale();
          var _id = facility_lists[i].id;

          var _mapUrl =
            "https://www.google.com/maps/search/?api=1&query=" +
            facility_lists[i].latitude +
            "," +
            facility_lists[i].longitude;
          var categories = facility_lists[i].categories;

          var SORT_LIST = [
            "parking_and_facility_1",
            "parking_and_facility_2",
            "parking_and_facility_3",
            "parking_and_facility_4",
            "parking_and_facility_5",
            "parking_and_facility_6",
            "parking_and_facility_14",
            "parking_and_facility_7",
            "parking_and_facility_13",
            "parking_and_facility_8",
            "parking_and_facility_9",
            "parking_and_facility_10",
            "parking_and_facility_11",
            "parking_and_facility_12",
            "toilet_1",
            "toilet_2",
            "toilet_3",
            "toilet_4",
            "toilet_5",
            "toilet_6",
            "toilet_7",
            "toilet_8",
            "toilet_9",
            "transportation_1",
            "transportation_2",
            "transportation_3",
            "transportation_4",
            "transportation_5",
            "eating_and_drinking_1",
            "eating_and_drinking_2",
            "eating_and_drinking_3",
            "eating_and_drinking_4",
            "eating_and_drinking_5",
            "eating_and_drinking_6",
            "eating_and_drinking_7",
            "eating_and_drinking_8",
            "hotel_accommodation_1",
            "hotel_accommodation_2",
            "hotel_accommodation_3",
            "hotel_accommodation_4",
            "hotel_accommodation_5",
            "hotel_accommodation_6",
            "hotel_accommodation_7",
            "hotel_accommodation_8",
            "hotel_accommodation_9",
          ];
          categories.sort(
            (a, b) => SORT_LIST.indexOf(a.code) - SORT_LIST.indexOf(b.code),
          );

          _url = location.origin + "/" + _lang + "/facilities/" + _id;
          var _content = '<div class="content">';
          _content +=
            '<h3 class="h6 facility-name">' + facility_lists[i].title + "</h3>";
          // if(facility_lists[i].tel) {
          //   _content += '<p class="facility-tel">' + facility_lists[i].tel + '</p>'
          // }
          if (categories) {
            _content += '<div class="facility-barrier-free-section">';
            _content += '<ul class="facility-category-lists x32">';
            for (var ic = 0; ic < categories.length; ic++) {
              // purposeカテゴリを除外（バリアフリー関連のピクトグラムのみ表示）
              if (categories[ic].category_type !== 'purpose') {
                // _content += '<li class="facility-category"><span class="facility-category-code"><i id="' + categories[ic].code + '"'+ ' class="facility-category btn-barrier-free"></i>' + categories[ic].name + '</span></li>'
                _content +=
                  '<li tabindex="0" class="facility-category"><span tabindex="0" id="' +
                  categories[ic].code +
                  '"' +
                  ' class="facility-category-code btn-barrier-free"></li>';
              }
            }
            _content += "</ul>";
            _content += "</div>";
          }
          _content += '<div class="function-section float-left">';
          _content += '<a class="nav-link" href="' + _url + '">';
          _content += '<i class="pe-7s-search"></i>' + detail;
          _content += "</a>";
          _content += '<a class="nav-link" href="' + _mapUrl + '">';
          _content += '<i class="pe-7s-map"></i>' + route;
          _content += "</a>";
          _content += "</div>";
          _content += "</div>";

          if (infoWindow) {
            infoWindow.close();
          }

          infoWindow = new google.maps.InfoWindow({
            content: _content,
          });

          infoWindow.open(map, target);

          break;
        }
      }
    }
  },
  scrollToSection: function (ele) {
    var scrollToTargetId;
    var scrollToSection;
    var topPos = 0;

    scrollToTargetId = ele.getAttribute("data-target");
    scrollToSection = ele.getAttribute("data-section");

    var btnSections = document.querySelectorAll(".btn-section");
    btnSections.forEach(function (target) {
      var target_id = target.getAttribute("data-target");
      var section = target.getAttribute("data-section");
      if (section && section <= scrollToSection) {
        if (target_id) {
          var d = document.getElementById(target_id);
          if (d) {
            topPos = d.offsetTop;
          }
        }
      }
    });
    $("#left_container").animate({ scrollTop: topPos }, "slow");
  },
  show: function (info) {
    this.init();
  },
  prev: function () {
    location.href = location.pathname + "/prev";
  },
  next: function () {
    location.href = location.pathname + "/next";
  },
  setMessage: function (messageText) {
    if (flash_messages) {
      flash_messages.innerHTML = "";
      var div = document.createElement("div");
      div.setAttribute(
        "class",
        "alert alert-danger alert-dismissable flash-message",
      );
      div.innerText = messageText;
      var button = document.createElement("button");
      button.setAttribute("type", "button");
      button.setAttribute("class", "close");
      button.setAttribute("data-dismiss", "alert");
      button.setAttribute("aria-hidden", "true");
      button.innerText = "x";
      div.appendChild(button);
      flash_messages.appendChild(div);
    }
  },
  // 大エリアの中心点（centerpoint.txtに基づく）
  toCentralArea: function () {
    var latitude = 37.7565687;  // 福島駅
    var longitude = 140.4597355;
    this.drawMap(latitude, longitude);
  },
  toNorthArea: function () {
    var latitude = 37.7969101;  // 北信学習センター
    var longitude = 140.4789657;
    this.drawMap(latitude, longitude);
  },
  toWestArea: function () {
    var latitude = 37.7234141;  // とうほう・みんなのスタジアム（県営あづま陸上競技場）
    var longitude = 140.3613488;
    this.drawMap(latitude, longitude);
  },
  toEastArea: function () {
    var latitude = 37.7495891;  // 渡利学習センター
    var longitude = 140.4852060;
    this.drawMap(latitude, longitude);
  },
  toSouthArea: function () {
    var latitude = 37.6978872;  // 蓬莱支所
    var longitude = 140.472317;
    this.drawMap(latitude, longitude);
  },
  // 小エリアの中心点（既存の座標を維持）
  toFukushimaCity: function () {
    var latitude = 37.7565687;  // 福島駅
    var longitude = 140.4597355;
    this.drawMap(latitude, longitude);
  },
  toIizaka: function () {
    var latitude = 37.8303601;
    var longitude = 140.4546566;
    this.drawMap(latitude, longitude);
  },
  toTsuchiyu: function () {
    var latitude = 37.6822407;
    var longitude = 140.3265106;
    this.drawMap(latitude, longitude);
  },
  toTakayu: function () {
    var latitude = 37.7525393;
    var longitude = 140.3049014;
    this.drawMap(latitude, longitude);
  },
  toSuburbs: function () {
    var latitude = 37.7542123;
    var longitude = 140.4570277;
    this.drawMap(latitude, longitude, 12);
  },
  mobileAccess: function () {
    var isMobile = false;
    if (
      window.matchMedia &&
      window.matchMedia("(max-device-width: 640px)").matches
    ) {
      isMobile = true;
    }
    return isMobile;
  },
  storageAvailable: function (type) {
    var storage;
    try {
      storage = window[type];
      var x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === "QuotaExceededError" ||
          // Firefox
          e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    }
  },
  getLocale: function () {
    var result = null;
    var param = GetQueryString();

    if (this.storageAvailable("sessionStorage")) {
      result = sessionStorage.getItem("language_type");
    } else {
      if (param) {
        result = param["locale"];
      } else {
        result = location.pathname.substring(1, 3);
      }
      if (result == "fa") {
        result = "ja";
      }
    }
    if (result == null) {
      result = "ja";
    }
    return result;
  },
  setLocale: function (ele) {
    var locale = ele.dataset.locale;
    if (this.storageAvailable("sessionStorage")) {
      sessionStorage.setItem("language_type", locale);
    }
  },
};

$(document).on("keydown", function (event) {
  if (event.key === "Enter") {
    // 特定のボタンを取得し、クリックをトリガー
    $("#btn_search_facility_name").click();
  }
});

// ページ読み込み時にURLパラメータから施設名検索を実行
$(document).ready(function() {
  var params = GetQueryString();
  if (params && params.facility) {
    // 施設名が入力されている場合は自動的に検索実行
    var facilityNameInput = document.getElementById("facility_name");
    if (facilityNameInput && facilityNameInput.value) {
      // 少し遅延させて検索を実行（マップ初期化後に実行）
      setTimeout(function() {
        Facilities.setResult();
      }, 500);
    }
  }
});
